import React, { useState, useEffect } from 'react';
import AppRouter from './routes/AppRouter';
import { getCurrentUser, logout } from './services/api';
import {
  GlobalContextProvider,
  useGlobalContext,
} from './contexts/GlobalContext';
import { FeatureFlagProvider } from './contexts/FeatureFlagContext';

function AppContent() {
  const { clearStoredData } = useGlobalContext();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      getCurrentUser()
        .then(userData => {
          setUser(userData);
        })
        .catch(error => {
          console.error('Error fetching user:', error);
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const handleLogin = userData => {
    setUser(userData);
  };

  const handleLogout = () => {
    logout();
    clearStoredData(); // Clear global context data
    setUser(null);
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="App">
      <AppRouter user={user} onLogin={handleLogin} onLogout={handleLogout} />
    </div>
  );
}

function App() {
  return (
    <FeatureFlagProvider>
      <GlobalContextProvider>
        <AppContent />
      </GlobalContextProvider>
    </FeatureFlagProvider>
  );
}

export default App;
